import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { VoiceOrderModal } from "@/components/VoiceOrderModal";
import { useSiteManagerPrefetch } from "@/hooks/useSiteManagerPrefetch";

export function SiteManagerContent({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();
  const [voiceModalOpen, setVoiceModalOpen] = useState(false);
  useSiteManagerPrefetch();

  const handleOrderParsed = (parsedOrder: any) => {
    setVoiceModalOpen(false);
    if (parsedOrder) {
      navigate("/site/betonnage/new", {
        state: { parsedOrder },
      });
    }
  };

  return (
    <>
      {children}
      <VoiceOrderModal
        open={voiceModalOpen}
        onOpenChange={setVoiceModalOpen}
        onOrderParsed={handleOrderParsed}
      />
    </>
  );
}
